module.exports = __webpack_public_path__ + "img/empty.fec38a81.svg";